import type { IconSvgObject } from './types';

const EntranceStairsIcon: IconSvgObject = [
  ["path", { d: "M4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V10Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 18H8C7.44772 18 7 18.4477 7 19V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M20 14H12C11.4477 14 11 14.4477 11 15V18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M19.5 10H16C15.4477 10 15 10.4477 15 11V14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default EntranceStairsIcon;
